import {
    createForm,
    createObjectField,
    createPrimitiveField,
    createUnionField,
    literal,
    nullable,
    type ValidationError,
} from '@adv-frontend/form-kit';
import { OrderDeliveryServices, type ServiceType } from '@/shared/api/order';

export const deliveryIntervalForm = createForm({
    name: 'DeliveryIntervalForm',
    fields: {
        deliveryInterval: createUnionField({
            key: 'type',
            defaultValue: { type: 'notInterval' },
            fields: [
                createObjectField({
                    validators: (createValidators) =>
                        createValidators<ValidationError<'REQUIRED_DELIVERY_INTERVAL'>>({}),
                    fields: {
                        type: createPrimitiveField({ defaultValue: literal<'notInterval'>('notInterval') }),
                    },
                }),
                createObjectField({
                    validators: (createValidators) =>
                        createValidators<ValidationError<'REQUIRED_DELIVERY_INTERVAL'>>({}),
                    fields: {
                        type: createPrimitiveField({ defaultValue: literal<'interval'>('interval') }),
                        from: createPrimitiveField({ defaultValue: Date.now() }),
                        to: createPrimitiveField({ defaultValue: Date.now() }),
                        serviceType: createPrimitiveField({
                            defaultValue: literal<ServiceType>(OrderDeliveryServices.YANDEX_DELIVERY),
                        }),
                        price: createPrimitiveField({ defaultValue: nullable<string>(null) }),
                        currency: createPrimitiveField({ defaultValue: nullable<string>(null) }),
                    },
                }),
            ],
        }),
    },
    onSubmit: async (values) => values,
});
